<template lang="pug">
  .pay-checkboxGroup-container(:class="{'flex': displayColumn === 'h'}")
    //- label.mr-16.h-21.block.mb-8(v-if="label && showLabel")
    //-   span {{label}} 
    //-   span.text-red-200.mr-1(v-if="required") *
    .radioBlock.justify-start(:class="{'flex': displayColumn != 'h'}")
      label.select-none.radioEach.relative.cursor-pointer.pl-20.mr-16.mb-8(v-for="(item,index) in options" :key="item.val" 
      :class="{'flex': displayColumn === 'h', 'block': optionDisplayColumn ,'inline-block' : !optionDisplayColumn}"
      )
        input.absolute.opacity-0.left-0.cursor-pointer(:value="item.val" :id="item.val" :checked="item.val" type="radio" v-model="radioValue" :name="label" :disabled="item.disabled" )
        span.ml-8.pt-2.block {{item.name}} 
        span.h-20.w-20.checkmark.absolute.top-0.left-0.border.border-black.transform.rounded-full(class="top-1/2 -translate-y-1/2" :class="{'border-error': error && !item.disabled}")
    .error.h-21.flex.items-center(v-show="error")
      small.text-red-200 {{error}}
</template>

<script>
export default {
  name: 'RadioboxGroup',
  props: {
    error: String,
    optionDisplayColumn: {
      type: Boolean,
      required: false,
      default:false,
    },
    displayColumn: {
      type: String,
      default: '',
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    label:  {
      type: String,
      default: 'hhh',
      required: false,
    },
    showLabel:{
      type: Boolean,
      required: false,
      default:false,
    },
    value: {
      type: [String, Boolean, Number],
      required: true,
    },
    required: Boolean,
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    radioValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('changeValue', val);
      }
    }
  },
  watch : {
  }
};
</script>

<style lang="scss" scoped>

// .radioEach input{
//   &:checked ~ .checkmark {
//     @apply bg-white border border-main-deep;
//   }
//   &:disabled ~ .checkmark {
//   @apply bg-grey-b4;
// }
// }


//打勾後
.radioEach input{
  &:checked ~ .checkmark {
  }
  &:disabled ~ .checkmark {
    opacity: 0.6;
    @apply border-black ;
    &:before {
      display: none;
    }
  }
  &:disabled ~ span {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:checked{
    &:disabled ~ .checkmark {
    }
  }
}

.radioEach input:disabled ~ .checkmark {
  // @apply bg-grey-b4;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.radioEach input:checked ~ .checkmark:after {
  display: inline-block;
}

.radioEach .checkmark:after {
  @apply bg-main-deep;
  content: ' ';
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


//hover

.radioEach:hover{
  input:not([disabled]) {
    & ~ .checkmark{ //沒打勾的邊邊變色
      @apply border-main-deep;
    }
  }
}

//active

.radioEach:active{
  input:not([disabled]) {
    & ~ .checkmark{
      background-color: #1247b2 !important;
      @apply border-main-deep ;
    }
  }
  
}





</style>
